export default __webpack_public_path__ + "static/media/appraiserbff.ac16f250.png";